import * as Yup from 'yup';
import { IParams } from '../../../../../../shared/types/redirectParams';

export const initialValues: IParams = {
    code: '',
    class: '',
    name: '',
    extra: '',
    extra2: '',
    parent: '',
    active: true,
};

export const validationSchema = () =>
    Yup.object({
        name: Yup.string().required('El nombre es obligatorio'),
        extra: Yup.string().required('El correo es obligatorio'),
        parent: Yup.string().required('El área es obligatoria'),
    });
